import React from "react";
import DiscussionForumBlock from "../components/DiscussionForumBlock";

function DiscussionForum() {
  return (
    <div className="px-6 py-6 space-y-6">
      <div className="mb-6">
        <h1 className="text-xl font-bold text-white mb-2">Discussion Forum</h1>
        <p className="text-slate-300">
          Join discussions with legal professionals
        </p>
      </div>

      <DiscussionForumBlock />
    </div>
  );
}

export default DiscussionForum;
